// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NumberWithUnitForm-module__NumberInput__aHehp {
    max-width: var(--ds-73x);
}

.NumberWithUnitForm-module__UnitInput__rl5Xt {
    max-width: var(--ds-27x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NumberInput": `NumberWithUnitForm-module__NumberInput__aHehp`,
	"UnitInput": `NumberWithUnitForm-module__UnitInput__rl5Xt`
};
export default ___CSS_LOADER_EXPORT___;
